import React from "react";
import JsxSyntaxHighlighter from "../../ui/JsxSyntaxHighlighter";
import ApiLink from "../../ui/ApiLink";

export default function CallProFile() {
  return (
    <div>
      <JsxSyntaxHighlighter>
        {`callProFile(config: MinibeakConfig): Promise<ProFileRawResponse|Response>`}
      </JsxSyntaxHighlighter>

      <p>Performs a call against json-api based on the given configuration.</p>

      <p>
        Returns a promise resolving to the response returned by the api. When
        the response Content-Type is json, the parsed json value is returned.
        Otherwise the fetch response is returned directly.
      </p>

      <p>
        Fails with <ApiLink name="ResponseNotOkError" /> when the response does
        not have an http status in the 200-series. This is a plain promise
        rejection: <code>throwErrors</code> has no effect here, and React error
        boundaries never see it. Catch it yourself.
      </p>

      <JsxSyntaxHighlighter>
        {`import { useProFileApi, callProFile, defaultConfig } from "@dossier/minibeak";


async function doSelectEmployment(employmentId, delegatorEmploymentId) {
  return callProFile({
    ...defaultConfig,

    path: "/session/selectEmployment",
    method: "post",
    body: {
      data: {
        type: "session",
        attributes: {
          employmentId,
          delegatorEmploymentId,
          permanentLogin: false,
        },
      },
    },
  });
}

// You don't need to bind this, you can just use it.
// For example:

function MyFunctionalComponent(props) {
  const session = useProFile(/* ... */);

  async function handleSelectEmployment(employmentId, delegatorEmploymentId) {
    // Usually you don't use the result of actions.
    // Instead you just refresh affected resources:

    await doSelectEmployment(employmentId, delegatorEmploymentId)
    await session.refresh();
  }


  // If you want to use the result, you can do this:

  async function handleSelectEmploymentAndUseResult(employmentId, delegatorEmploymentId) {
    const rawResult = await doSelectEmployment(employmentId, delegatorEmploymentId)

    const selectEmploymentResult = processProFileResult(rawResult);

    console.log("Result of call, with linked resources:", selectEmploymentResult.data);
    console.log("All included resources by type and id:", selectEmploymentResult.resources);

    await session.refresh();
  }


    /* ... */
  }`}
      </JsxSyntaxHighlighter>
    </div>
  );
}
